export default __webpack_public_path__ + "static/media/ChaseIO_FrontCounter.c28b116d.jpg";